export default [
    {
        id: 1,
        name_ca: 'Desconegut',
        name_es: 'Desconocido',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Estucat monocapa',
        name_es: 'Estucado monocapa',
        name_en: 'Stucco, monolayer'
    }, {
        id: 3,
        name_ca: 'Estucat venecià',
        name_es: 'Estucado veneciano',
        name_en: 'Venetian stucco'
    }, {
        id: 4,
        name_ca: 'Arrebossat i pintat',
        name_es: 'Rebozado y pintado',
        name_en: 'Coated and painted'
    }, {
        id: 5,
        name_ca: 'Acabat pintat',
        name_es: 'Acabado pintado',
        name_en: 'Painted'
    }, {
        id: 6,
        name_ca: 'Maó obra vista',
        name_es: 'Ladrillo obra vista',
        name_en: 'Brickwork'
    }, {
        id: 7,
        name_ca: 'Formigó',
        name_es: 'Hormigón',
        name_en: 'Concrete'
    }, {
        id: 8,
        name_ca: 'Pedra',
        name_es: 'Piedra',
        name_en: 'Stone'
    }, {
        id: 9,
        name_ca: 'Panells de formigó reforçats amb fibra de vidre (GRC)',
        name_es: 'Paneles de hormigón reforzados con fibra de vidrio (GRC)',
        name_en: 'Glass fiber Reinforced Concrete panels'
    }, {
        id: 10,
        name_ca: 'Xapa ondulada d\'alumini',
        name_es: 'Chapa ondulada de aluminio',
        name_en: 'Corrugated aluminum sheet'
    }, {
        id: 11,
        name_ca: 'Bloc de formigó',
        name_es: 'Bloque de hormigón',
        name_en: 'Concrete block'
    }, {
        id: 12,
        name_ca: 'Policarbonat',
        name_es: 'Policarbonato',
        name_en: 'Polycarbonate'
    }, {
        id: 13,
        name_ca: 'Termoargila vista',
        name_es: 'Termoarcilla vista',
        name_en: 'Thermoclay'
    }
]





// WEBPACK FOOTER //
// ./src/options/external_enclosures.js